module.exports = __webpack_public_path__ + "img/OBUHomePage_01.65cf1f65.png";